import React from 'react'
import Loading from '../Loading'
import jobRepo from '../../requests/jobs'
import TotalBar from './TotalBar'
import CONFIG from '../../config'
import WidgetHeader from './WidgetHeader'
import moment from 'moment'
import _ from 'lodash'

export default class JobTotals extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: true,
      time: moment().format('YYYY-MM-DD'),
      counter: {}
    }
  }
  componentWillMount () {
    if(!this.props.time || !this.state.time){
      this.setState({time: moment().format('YYYY-MM-DD')})
    }
    this.loadData()
  }
  loadData() {
    // this.setState({loading: true})
    jobRepo.getJobCounterByStatus(this.state.time).then(data => {
      if(data && _.isObjectLike(data)){
        this.setState({ counter:data, loading: false})
      }
    })
  }
  async onTimeChange(time){
   await this.setState({time})
    this.loadData()
  }
  render(){
    if(this.state.loading === true){
      return(<Loading/>)
    }
    let totalP = (!this.state.counter.total || this.state.counter.total <= 0)? 0 : 100
    let donePercent = (this.state.counter.total <= 0 || this.state.counter.done === 0 ) ? 0 : (this.state.counter.done * 100)/ this.state.counter.total
    let errorPercent = (this.state.counter.total <= 0 || this.state.counter.done === 0 ) ? 0 : (this.state.counter.error * 100)/ this.state.counter.total
    let runningPercent = (this.state.counter.total <= 0 || this.state.counter.done === 0 ) ? 0 : (this.state.counter.running * 100)/ this.state.counter.total
    const time_opt = [
      { value: '12', label: 'Last 12 Hours' },
      { value: '24', label: 'Last 24 Hours' },
      { value: `${2 * 24}`, label: 'Last 2 Days' },
      { value: `${5 * 24}`, label: 'Last 5 Days' },
      { value: `${7 * 24}`, label: 'Last Week' }
    ]
    return(
      <div>
        <WidgetHeader title = 'Total Jobs' options = {time_opt} time = {this.state.time} onChange={(time) =>{this.onTimeChange(time)}}/>
        <TotalBar label='Done' status={CONFIG.STATUS.DONE} amount={this.state.counter.done} percent={donePercent}/>
        <TotalBar label='Error' status={CONFIG.STATUS.ERROR} amount={this.state.counter.error} percent={errorPercent}/>
        <TotalBar label='Running' status={CONFIG.STATUS.RUNNING} amount={this.state.counter.running} percent={runningPercent}/>
        <TotalBar label='Total' status={''} amount={this.state.counter.total} percent={totalP}/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/JobTotals.js